/** WCAG relative luminance + contrast ratio for #rrggbb colours. */
export function luminance(hex: string): number {
  const n = parseInt(hex.slice(1), 16);
  const ch = [16, 8, 0].map((s) => ((n >> s) & 255) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * ch[0]! + 0.7152 * ch[1]! + 0.0722 * ch[2]!;
}

export function contrast(h1: string, h2: string): number {
  const a = luminance(h1);
  const b = luminance(h2);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
}

export const isHex = (v: string): boolean => /^#[0-9a-f]{6}$/i.test(v);
